import React from 'react'
import LogoFile from '../assets/svg/logo_UnderwaterMuse.svg'

const Logo = () => {
  return <div className="App-logo-container">
    <img src={LogoFile} className="App-logo" alt="Underwater Muse Logo" />
  </div>
}

export default Logo